export default {
  lang: null,
  defaultLang: 'ar',
  supportedLangs: ['en', 'ar'],
  rtlLangs: ['ar'],
  category_enums: [],
  sub_category_enums: [],
  color_enums: [],
  year_enums: [],
  brand_enums: [],
  model_enums: [],
  model_included_enums: [],
  garage_enums: [],
  branch_enums: [],
  provider_enums: [],
  features_enums: [],
  license_type_enums: [],
  language_enums: [],
  drivers_available_nationality_enums: [],
  nationality_enums: [],
  driver_list_enums: [],
  admins_enums: [],
  roles_enums: [],
  active_roles_enums: [],
  clients_list_enums: [],
  services_type_list_enums: [],
  city_enums: [],
  damage_level_enums: [],
  damage_area_enums: [],
  body_damage_area_enums: [],
  user_info: {},
  user_info_loaded: false,
  client_info: {},
  companies_enums: [],
  insurance_company_enums: [],
  regions_enums: [],
  provinces_enums: [],
  zone_enums: [],
  pos_enums: [],
  mobile_enums: [],
  services_enums: [],
  driver_availability: {},
  vehicle_availability: {},
  promo_code_enums: [],
  LTA_enums: [],
  clientType_enums: [],
  account_enums: [],
  proforma_invoice_enums: [],
  JV_enums: [],
  reservation_list_enums: [],
  remote_finance_account_enums: [],
  tax_type_enums: [],
  tax_type_zoho_enums: [],
  operator: '',
  training_type_enums: [],
  tax_type_odoo_enums: [],
  odoo_remote_finance_account_enums: [],
  product_enums: [],
  pricing_lists_enums: [],
  tga_type_enums: [],
  religion_enums: [],
  client_grade_enums: [],
  reservation_category_enums: [],
  service_category_enums: [],
  contract_type_enums: [],
  driver_username_enums: [],
  client_username_enums: [],
  resource_request_username_enums: [],
  user_enums: [],
  missing_request_payload: null,
  vehicle_type_enums: [],
  blanket_order_enums: [],
  kpi_reason_enums: [],
  client_city_enums: [],
  client_country_enums: [],
  toaster_message: {},
  available_reservation_list_enums: [],
  change_password_token: null,
  shift_type_enums: [],
  driver_employee_id_list_enums: [],
  contract_id_enums: [],
  contract_id_client_enums: [],
  payment_method_enums: [],
  client_contact_person_enums: [],
  entity_enums: [],
  username_enums: [],
  admin_configuration_enums: [],
  driver_employee_id_enums: [],
  routes_enums: [],
  workflow_enums: [],
  proforma_invoice_number_enums: [],
  user_name_enums: [],
  blanket_order_order_code_enums: [],
  service_point_enums: [],
  water_source_enums: [],
  branch_garage_enums: [],
  certificates_of_completion_enums: [],
  certificate_of_completion_profile_enums: [],
  trip_complete_note_enums: [],
  trip_rating_enums: [],
  get_contractors_contracts: [],
  get_tank_enums: [],
  available_zone_enums: [],
  certificateLogs: [],
  tanker_type_enums: [],
}